<template>
  <div class="detail-download">
    <div class="product-info">
      <div class="product-banner">
        <img :src="detail.cn_download_banner" alt="">
      </div>
      <div class="introduce">
        <h3>{{ detail.name }}</h3>
        <p>{{ detail.title_content }}</p>
      </div>
    </div>
    <div class="product-videos">
      <h3>视频</h3>
      <div class="product-video-list">
        <div class="product-video-item" v-for="item in detail.cn_video_data">
          <div class="video-cover" @click="openVideo(item.video)">
            <img :data-src="item.image" class="lazyload" alt=""/>
            <img class="icon-play" :src="require('@/assets/common/img/play.svg')" alt="">
          </div>

          <div class="product-video-info">
            <h4 class="line2">{{ item.title }}</h4>
            <p class="line2">{{ item.desc }}</p>
<!--            <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.video)" :class="{ active:item.active, on: !item.active, dte: channel_id == 2 }" class="download-button">下载</a>-->
            <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.video)" :class="{ dte: channel_id == 2 }" class="download-button">下载</a>
          </div>
        </div>

      </div>
    </div>

    <div class="product-brochures">
      <h3>手册</h3>
      <div class="product-brochures-list">
        <div class="product-brochures-item "  v-for="item in detail.cn_resource_data">
          <h4 class="line2" :class="{dte: channel_id == 2}" @click.stop="openFile(item.resource)">{{ item.title }}</h4>
          <p class="line2">{{ item.date }}</p>
<!--          <a href="javascript:void(0)" @click.stop="downloadFile(item, item.title, item.resource)" :class="{ active:item.active, on: !item.active, dte: channel_id == 2 }" class="download-button">下载</a>-->
          <a href="javascript:void(0)" @click.stop="downloadFile(item, item.title, item.resource)" :class="{ dte: channel_id == 2 }" class="download-button">下载</a>
        </div>

      </div>
    </div>

    <div class="product-image">
      <h3>图片</h3>
      <div class="product-image-list">
        <div class="product-image-item" v-for="item in detail.cn_images_data">
          <div class="product-image-item-image">
            <img :data-src="item.image" class="lazyload" alt="" />
          </div>
<!--          <a href="javascript:void(0)" @click="downloadImage(item, item.title, item.image)" :class="{ active:item.active, on: !item.active, dte: channel_id == 2 }" class="download-button">下载</a>-->
          <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.image)" :class="{ dte: channel_id == 2 }" class="download-button">下载</a>
        </div>
      </div>
    </div>
    <dialogVideo ref="dialogVideoRef" @downloadFile="downloadFile"></dialogVideo>
  </div>
</template>

<script>

import dialogVideo from "./dialog-video.vue";
import {session} from "../../../storage/storage";
export default {
  name: 'detail-download',
  components: {
    dialogVideo
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      channel_id: 1,
    }
  },
  mounted() {
    this.channel_id = session.get('channel_id')
  },
  methods: {
    async downloadFile(item, name, urlStr) {
      const url = new URL(urlStr);
      const path = url.pathname.substring(1);
      const filename = name ? name : 'download';
      const ext = urlStr.split('.').pop()

      if(urlStr.includes('myqcloud.com')){
        this.$utils.handleDownloadUri(filename,urlStr)
      }else {
        this.$api.get_oss_sign_url({path:path,file_name: filename + '.' + ext}).then(async res => {
          // window.open(res.data)
          let uri = res.data
          let elt = document.createElement('a');
          elt.setAttribute('href', uri);
          elt.setAttribute('download', filename + '.' + ext);
          elt.style.display = 'none';
          document.body.appendChild(elt);
          elt.click();
          document.body.removeChild(elt);
        })
      }

    },
    openVideo(url){
      this.$refs.dialogVideoRef.open(url)
    },
    downloadImage(item, name, path){
      // item.active = true
      // this.$forceUpdate()
      window.open(path)
    },
    openFile(url){
      window.open(url)
    },
  }
}

</script>

<style scoped>
.detail-download h1, .detail-download h2, .detail-download h3, .detail-download h4, .detail-download h5, .detail-download p {
  margin: 0;
  padding: 0;
}

.line2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.detail-download {
  width: 1400px;
}
.detail-download img {
  display: block;
  width: 100%;
  height: 100%;
}
.detail-download h2 {
  font-size: 30px;
  color: #1b1b1b;
  font-weight: 500;
}
.detail-download h3 {
  font-size: 24px;
  color: #1b1b1b;
  font-weight: 500;
}
.detail-download h4 {
  font-size: 18px;
  font-weight: 500;
  color: #1b1b1b;
}
.detail-download p {
  color: #7d7d7d;
  font-size: 16px;
  line-height: 1.6;
}

.product-videos p {
  font-size: 12px;
}

.detail-download .download-button {
  font-size: 18px;
  color: #1b1b1b;
  cursor: pointer;
  border: 1px solid #1b1b1b;
  width: 128px;
  padding: 5px 0;
  text-align: center;
  border-radius: 8px;
  transition: all .3s linear 0s;
  display: block;
  text-decoration: none;
}
.detail-download .download-button:active {
  background-color: #d10707;
  color: #ffffff;
  border: 1px solid #d10707;

}

.detail-download .download-button.active {
  background-color: #d10707;
  color: #ffffff;
  border: 1px solid #d10707;

}
.detail-download .download-button.dte:active {
  background-color: #1a4698!important;
  color: #ffffff;
  border: 1px solid #1a4698!important;

}
.detail-download .download-button.active.dte {
  background-color: #1a4698!important;
  color: #ffffff;
  border: 1px solid #1a4698!important;

}
.product-info {
  margin-top: 91px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product-info .product-banner {
  width: 751px;
  height: 438px;
  margin-right: 50px;
  border-radius: 8px;
  overflow: hidden;
}
.product-info .product-banner img {

}
.product-info .introduce {
  width: 553px;
  margin-left: 50px;
}
.product-info .introduce h3 {}
.product-info .introduce p {
  margin-top: 31px;
}

.product-image,
.product-videos,
.product-brochures {
  margin-top: 132px;
}

.product-videos .product-video-list,
.product-brochures .product-brochures-list,
.product-image .product-image-list{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1400px;
}

.product-videos .product-video-list .product-video-item,
.product-brochures .product-brochures-list .product-brochures-item,
.product-image .product-image-list .product-image-item {
  width: 337px;
  cursor: pointer;
  margin-left: 17px;
  margin-top: 70px;
}
.product-videos .product-video-list .product-video-item:nth-child(4n+1),
.product-brochures .product-brochures-list .product-brochures-item:nth-child(4n+1),
.product-image .product-image-list .product-image-item:nth-child(3n+1) {
  margin-left: 0;
}
.product-videos .product-video-list .product-video-item .video-cover {
  width: 340px;
  height: 200px;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
}
.product-videos .product-video-list .product-video-item .video-cover .icon-play {
  width: 65px;
  height: 65px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.product-videos .product-video-list .product-video-item .product-video-info {
  margin-top: 31px;
  padding: 0 13px;
}

.product-videos .product-video-list .product-video-item .product-video-info h4 {
  margin-bottom: 18px;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  height: 47px;
}

.product-videos .product-video-list .product-video-item .product-video-info p {
  margin-bottom: 23px;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  height: 38px;
}

/*.product-image .product-image-list .product-image-item .download-button.on:hover,
.product-videos .product-video-list .product-video-item .product-video-info .download-button.on:hover,
.product-brochures .product-brochures-list .product-brochures-item .download-button.on:hover {
  color: #d10707;
  border-color: #d10707;
}*/
.product-image .product-image-list .product-image-item .download-button:hover,
.product-videos .product-video-list .product-video-item .product-video-info .download-button:hover,
.product-brochures .product-brochures-list .product-brochures-item .download-button:hover {
  color: #d10707;
  border-color: #d10707;
}

/*.product-image .product-image-list .product-image-item .download-button.dte.on:hover,
.product-videos .product-video-list .product-video-item .product-video-info .download-button.dte.on:hover,
.product-brochures .product-brochures-list .product-brochures-item .download-button.dte.on:hover {
  color: #1a4698!important;
  border-color: #1a4698!important;
}*/
.product-image .product-image-list .product-image-item .dte:hover,
.product-videos .product-video-list .product-video-item .product-video-info .dte:hover,
.product-brochures .product-brochures-list .product-brochures-item .dte:hover {
  color: #1a4698;
  border-color: #1a4698;
}

.product-brochures .product-brochures-list .product-brochures-item {
  width: 297px;
  padding: 24px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  cursor: default;
}

.product-brochures .product-brochures-list .product-brochures-item h4 {
  margin-bottom: 20px;
  cursor: pointer;
  transition: all .3s linear 0s;
  height: 50px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.product-brochures .product-brochures-list .product-brochures-item h4:hover {
  color: #d10707;
}

.product-brochures .product-brochures-list .product-brochures-item h4.dte:hover {
  color: #1a4698!important;
}

.product-brochures .product-brochures-list .product-brochures-item p {
  margin-bottom: 40px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}
.product-brochures .product-brochures-list .product-brochures-item .download-button,
.product-image .product-image-list .product-image-item .download-button {
  width: 160px;
  padding: 7px 0;
}
.product-brochures .product-brochures-list .product-brochures-item {
  //position: relative;
}
.product-brochures .product-brochures-list .product-brochures-item .download-button {
  //position: absolute;
  //bottom: 24px;
  //left: 20px;
}
.product-videos .product-video-list .product-video-item .product-video-info .download-button:active,
.product-brochures .product-brochures-list .product-brochures-item .download-button:active,
.product-image .product-image-list .product-image-item .download-button:active {
  background-color: #d10707;
  color: #ffffff;
}

.product-videos .product-video-list .product-video-item .product-video-info .dte:active,
.product-brochures .product-brochures-list .product-brochures-item .dte:active,
.product-image .product-image-list .product-image-item .dte:active {
  background-color: #1a4698;
  color: #ffffff;
}

.product-image .product-image-list .product-image-item .product-image-item-image {
  border-radius: 8px;
  overflow: hidden;
  cursor: default;
  width: 455px;
  height: 269px;
}

.product-image .product-image-list .product-image-item .product-image-item-image img{
  object-fit: cover;
  object-position: center;
  display: block;
}

.product-image .product-image-list .product-image-item .download-button {
  margin-top: 39px;
}
.product-image .product-image-list .product-image-item {
  width: 455px;
}
</style>
